/**
 * 포트폴리오 그리드 진입 애니메이션
 * 스크롤로 각 행이 화면에 들어오면, 그 행의 카드들이 왼쪽부터 한 칸씩
 * 아래에서 위로 떠오르며(stagger) 등장한다.
 * 초기 상태(투명 + translateY)는 SCSS 가 소유하고, 여기서는 .to() 로만 전환한다.
 */
export function initPortfolio() {
  const grid = document.querySelector("[data-portfolio]");
  if (!grid) return;

  const cards = Array.from(grid.querySelectorAll(".portfolio-card"));
  if (!cards.length) return;

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  const hasGsap = typeof window.gsap !== "undefined";
  const hasScrollTrigger = typeof window.ScrollTrigger !== "undefined";

  // 모션 비활성 / 라이브러리 부재 시: 숨김 해제만 하고 종료
  if (reduceMotion || !hasGsap || !hasScrollTrigger) {
    cards.forEach((card) => card.classList.add("is-shown"));
    return;
  }

  // 행 단위로 화면에 들어오는 카드들을 묶어(batch) 왼쪽부터 순차 등장
  window.ScrollTrigger.batch(cards, {
    start: "top 88%",
    onEnter: (batch) => {
      window.gsap.to(batch, {
        opacity: 1,
        y: 0,
        duration: 0.85,
        ease: "power3.out",
        stagger: 0.12,
        overwrite: true,
      });
    },
  });

  window.ScrollTrigger.refresh();
}
